var React = require('react');

function Magnifier24x24 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Size=24x24, Invert=On","stroke":"currentColor","strokeWidth":"2"},[React.createElement("circle",{"id":"Ellipse 1","cx":"9.744","cy":"9.744","r":"8.744","key":0}),React.createElement("path",{"id":"Vector 160","d":"M16.105 16.105l6.632 6.632","key":1})]));
}

Magnifier24x24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Magnifier24x24;

Magnifier24x24.default = Magnifier24x24;
